// core/guards/role.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ToasterService } from '@shared/services/toaster.service';
import { Router } from '@angular/router';

export const roleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  const toaster = inject(ToasterService);
  const router = inject(Router);

  const requiredRoles = route.data?.['roles'] as string[] | undefined;

  // 1. Check if user is logged in
  if (!authService.isAuthenticated()) {
    toaster.showError('You must be logged in to access this page.');
    router.navigate(['/login']);
    return false;
  }

  // 2. Get user data and role
  const user = authService.getUserData();
  const userRole = user?.role;

  // 3. Allow if no roles are defined (public route)
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  // 4. Allow if user's role is in allowed list
  if (userRole && requiredRoles.includes(userRole)) {
    return true;
  }

  // 5. Deny access
  toaster.showError('Access denied: insufficient permissions.');
  router.navigate(['/unauthorized']);
  return false;
};
